import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ThemeSettingService } from '../services/theme-setting.service';
import { LoginService } from '../services/login.service';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from '../services/confirmation.service';
import { HeaderService } from '../services/header.service';
import { MessagePopupService } from '../services/message-popup.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(router, route, themeSettingService, loginService, confirmationService, headerService, messagePopupService, workflowReturnService) {
        this.router = router;
        this.route = route;
        this.themeSettingService = themeSettingService;
        this.loginService = loginService;
        this.confirmationService = confirmationService;
        this.headerService = headerService;
        this.messagePopupService = messagePopupService;
        this.workflowReturnService = workflowReturnService;
        this.isBusy = false;
        this.passwordValue = '';
        this.confirmPasswordValue = '';
        this.valid = false;
        this.isPageLoading = false;
        // this.regexPassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$";
        this.regexPassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,}$";
    }
    ResetPasswordComponent.prototype.ngOnInit = function () {
        this.oneTimeKey = this.route.snapshot.paramMap.get('oneTimeKey');
        this.userId = this.route.snapshot.paramMap.get('userId');
        this.loaderConfig = this.themeSettingService.getTheme();
        this.headerService.displayMenu(false);
        this.checkOneTimeKey();
    };
    ResetPasswordComponent.prototype.checkOneTimeKey = function () {
        var _this = this;
        this.isPageLoading = true;
        this.headerService.validateKey(this.userId, this.oneTimeKey).subscribe(function (result) {
            _this.isBusy = false;
            _this.isPageLoading = false;
            if (result) {
                _this.handleWorkflowReturn(result);
            }
            else {
                _this.messagePopupService.popMessage("Error", "One time key is not valid.", ["OK"]).subscribe(function (respond) {
                });
            }
        }, function (error) {
            _this.isPageLoading = false;
        });
    };
    ResetPasswordComponent.prototype.submit = function (password, confirmPassword) {
        var _this = this;
        if (this.resetPasswordForm.valid) {
            this.isBusy = true;
            var param = new Array();
            param.push({ name: 'password', value: password });
            param.push({ name: 'confirmPassword', value: confirmPassword });
            param.push({ name: 'key', value: this.oneTimeKey });
            param.push({ name: 'userId', value: this.userId });
            this.loginService.resetPassword(param).subscribe(function (result) {
                if (result) {
                    _this.handleWorkflowReturn(result);
                }
                _this.isBusy = false;
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    ResetPasswordComponent.prototype.handleWorkflowReturn = function (result) {
        var _this = this;
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:// navigate
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
            case 1://message
                this.pullMessageBox(command);
                break;
            case 2://reload, does nothing, depends on refreshtype
                break;
            case 3://open something
                break;
            case 4://message
                this.pullMessageBox(command);
                break;
            case 8://messagenavigate
                this.router.navigate(["/"]);
                this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe(function (respond) {
                    if (respond.answer == "OK") {
                        _this.workflowReturnService.handleNavigateAndMessage(command, false);
                    }
                });
                break;
        }
    };
    ResetPasswordComponent.prototype.pullMessageBox = function (command) {
        var _this = this;
        this.confirmationService.confirm(command.Arguments[0], command.Arguments[1], ['OK'], false, '', false)
            .subscribe(function (respond) {
            if (respond.answer == 'OK') {
                _this.router.navigate(['/login']);
                _this.headerService.displayMenu(true);
            }
        });
    };
    ResetPasswordComponent.prototype.validate = function (password, confirmPassword, control) {
        var _this = this;
        if (password.value && confirmPassword.value) {
            if (password.value != confirmPassword.value) {
                this.valid = false;
                this.resetPasswordForm.control.get(control.name).setErrors({ noMatch: true });
            }
            else {
                var param = new Array();
                param.push({ name: 'password', value: password.value });
                param.push({ name: 'user', value: this.userId });
                this.loginService.validatePassword(param).subscribe(function (result) {
                    var object = JSON.parse(result);
                    _this.resetPasswordForm.control.get("password").setErrors(null);
                    _this.resetPasswordForm.control.get("confirmPassword").setErrors(null);
                    if (object.Arguments[1] != "OK") {
                        _this.valid = false;
                        if (_this.resetPasswordForm.control.get(control.name)) {
                            _this.resetPasswordForm.control.get(control.name).setErrors({ custom: object.Arguments[1] });
                        }
                    }
                    else {
                        _this.valid = true;
                    }
                });
            }
        }
    };
    return ResetPasswordComponent;
}());
export { ResetPasswordComponent };
